import { FC, useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { logoutAction } from "../../redux/actions/authAction";
import { connectAuthSocket, AuthEventCallback } from "../../util/authSocket";

const AuthLogoutListener: FC = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  const clientRef = useRef<ReturnType<typeof connectAuthSocket> | null>(null);

  useEffect(() => {
    if (!user?.id) {
      if (clientRef.current) {
        clientRef.current.deactivate();
        clientRef.current = null;
      }
      return;
    }

    const onEvent: AuthEventCallback = (event) => {
      if (event === "FORCE_LOGOUT") {
        dispatch(logoutAction());
      }
    };

    clientRef.current = connectAuthSocket(user.id, onEvent);

    return () => {
      if (clientRef.current) {
        clientRef.current.deactivate();
        clientRef.current = null;
      }
    };
  }, [dispatch, user?.id]);

  return null;
};

export default AuthLogoutListener;
